export const IMAGES = {
    hero: "https://images.unsplash.com/photo-1749063152078-bde9629563fc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBibGFjayUyMGNhYmluJTIwZm9yZXN0JTIwbGFrZXxlbnwwfHx8fDE3ODgwMzUzMjl8MA&ixlib=rb-4.1.0&q=85",
    domki1: "https://images.unsplash.com/photo-1761782791727-3994283faa88?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHw0fHxtaW5pbWFsaXN0JTIwY296eSUyMGNhYmluJTIwaW50ZXJpb3IlMjB3b29kfGVufDB8fHx8MTc4ODAzNTMyOXww&ixlib=rb-4.1.0&q=85",
    domki2: "https://images.unsplash.com/photo-1761322026605-2d5d35b58d41?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwzfHxtaW5pbWFsaXN0JTIwY296eSUyMGNhYmluJTIwaW50ZXJpb3IlMjB3b29kfGVufDB8fHx8MTc4ODAzNTMyOXww&ixlib=rb-4.1.0&q=85",
    domki3: "https://images.unsplash.com/photo-1698933787134-af2d451985c7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxtaW5pbWFsaXN0JTIwY296eSUyMGNhYmluJTIwaW50ZXJpb3IlMjB3b29kfGVufDB8fHx8MTc4ODAzNTMyOXww&ixlib=rb-4.1.0&q=85",
    activities: "https://images.unsplash.com/photo-1781185845058-cdef0056f13c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxyZWxheGluZyUyMG5hdHVyZSUyMGxpZmVzdHlsZSUyMGZvcmVzdCUyMHJpdmVyfGVufDB8fHx8MTc4ODAzNTMyOXww&ixlib=rb-4.1.0&q=85",
    hosts: "/images/agnieszka-gospodyni-tilio-domki-nad-liwcem-mazowsze.jpg",
    holistic: "/images/malgorzata-dec-masaz-gongi.jpg",
};

export const CONTACT = {
    phone: "+48 504 765 311",
    email: "kontakt@tilio.eu",
    address: "Sekłak, gmina Korytnica, powiat węgrowski, Mazowsze",
};

export const NAV_LINKS = [
    { label: "O Tilio", href: "#o-tilio" },
    { label: "Domki", href: "#domki" },
    { label: "Udogodnienia", href: "#udogodnienia" },
    { label: "Co robić", href: "#co-robic" },
    { label: "Opinie", href: "#opinie" },
    { label: "Dojazd", href: "#dojazd" },
];

export const FEATURES = [
    { icon: "Waves", title: "Tuż nad rzeką\nLiwiec", desc: "Prywatny dostęp do rzeki, kilka kroków od domku." },
    { icon: "Bath", title: "Sauna lub\njacuzzi", desc: "Prywatna sauna lub jacuzzi — tylko dla gości domku." },
    { icon: "Home", title: "3 domki dla 2–4 osób", desc: "Każdy z własnym tarasem i widokiem na wodę lub las." },
    { icon: "PawPrint", title: "Zwierzęta mile widziane", desc: "Ogrodzony teren i leśne ścieżki tuż za ogrodzeniem." },
    { icon: "SunSnow", title: "Całoroczny\npobyt", desc: "Ogrzewane domki czekają o każdej porze roku." },
    { iconImg: "/images/features/masaz-gongi-gabinet.png", title: "Masaż i\ngongi", desc: "100 m od domków\ngabinet masażu i\nsesji gongów." },
];

export const COTTAGES = [
    {
        id: "tilio",
        name: "TILIO",
        guests: "2–4 osoby",
        area: "25 m²",
        tags: ["Sauna", "Widok na wodę"],
        desc: "Domek najbliżej rzeki.\nSzum Liwca od rana do wieczora.\nSauna z widokiem na starą lipę.",
        image: "/images/tilio/tilio-domek-relax.jpg",
        imageAlt: "Domek Tilio nad Liwcem na Mazowszu",
        imageTitle: "Tilio – domek nad Liwcem na Mazowszu",
        gallery: [
            { src: "/images/tilio/tilio-domek-wnetrze-01.jpg", alt: "Wnętrze domku Tilio — antresola z sofą i sypialnią", title: "Tilio – wnętrze domku nad Liwcem" },
            { src: "/images/tilio/tilio-las-sekłak-02.jpg", alt: "Domek Tilio wśród drzew w Sekłaku na Mazowszu", title: "Tilio – domek w lesie w Sekłaku" },
            { src: "/images/tilio/tilio-taras-w-lesie-03.jpg", alt: "Zadaszony taras domku Tilio ze stołem i przeszkloną ścianą", title: "Tilio – taras domku nad Liwcem" },
            { src: "/images/tilio/tilio-domek-na-wynajem-liwiec-04.jpg", alt: "Rzeka Liwiec przy domku Tilio — stół z napojami nad wodą", title: "Tilio – nad rzeką Liwiec" },
            { src: "/images/tilio/tilio-domki-łaienka-05.jpg", alt: "Łazienka w domku Tilio z prysznicem i umywalką", title: "Tilio – łazienka w domku" },
            { src: "/images/tilio/tilio-mazowsze-sauna-06.jpg", alt: "Sauna beczka i balia w ogrodzie przy domku Tilio na Mazowszu", title: "Tilio – sauna i balia w ogrodzie" },
            { src: "/images/tilio/tilio-seklak-wynaje-07.jpg", alt: "Taras domku Tilio — poranna herbata i wypoczynek rodzinny", title: "Tilio – wypoczynek na tarasie" },
            { src: "/images/tilio/tilio-domek-natura-10.jpg", alt: "Domek Tilio z zadaszonym tarasem i hamakiem wśród zieleni", title: "Tilio – domek wśród natury" },
        ],
        features: ["Prywatna sauna", "Miejsce na ognisko", "Podwójne łóżko", "Aneks kuchenny", "Hamak", "Szybkie Wi-Fi", "Klimatyzacja i ogrzewanie", "Taras nad wodą", "Grill"],
    },
    {
        id: "o-sole-mio",
        name: "O SOLE MIO",
        guests: "2–4 osoby",
        area: "25 m²",
        tags: ["Jacuzzi", "Prywatny taras"],
        desc: "Jacuzzi na tarasie i duża przeszklona ściana — stworzony na spokojny wyjazd we dwoje.",
        image: "/images/o-sole-mio/o_sole_mio_domek-na-wynajem.jpg",
        imageAlt: "Domek O Sole Mio na wynajem nad Liwcem na Mazowszu",
        imageTitle: "O Sole Mio – domek na wynajem nad Liwcem",
        gallery: [
            { src: "/images/o-sole-mio/tilio-sełkak-salon-02.jpg", alt: "Salon domku O Sole Mio z antresolą i sofą" },
            { src: "/images/o-sole-mio/tilio-wynajem-domek-01.jpg", alt: "Taras domku O Sole Mio nad Liwcem na Mazowszu" },
            { src: "/images/o-sole-mio/tilio-sełkak-kuchnia-03.jpg", alt: "Kuchnia w domku O Sole Mio nad Liwcem" },
            { src: "/images/o-sole-mio/tilio-sełkak-grill-04.jpg", alt: "Grill przy domku O Sole Mio na Mazowszu" },
            { src: "/images/o-sole-mio/tilio-sełkak-balia-05.jpg", alt: "Balia przy domku O Sole Mio nad Liwcem" },
            { src: "/images/o-sole-mio/tilio-sekłak-jacuzzi-rzeka-mazowsze_liwiec-06.jpg", alt: "Jacuzzi przy domku O Sole Mio nad rzeką Liwiec" },
            { src: "/images/o-sole-mio/tilio-sełkak-łazienka-mazowsze-07.jpg", alt: "Łazienka w domku O Sole Mio na Mazowszu" },
            { src: "/images/o-sole-mio/tilio-sełkak-spanie-08.jpg", alt: "Sypialnia w domku O Sole Mio nad Liwcem" },
            { src: "/images/o-sole-mio/domek-wynajem-kawa-11.webp", alt: "Zestaw do parzenia kawy w domku O Sole Mio nad Liwcem" },
            { src: "/images/o-sole-mio/tilio-sełkak-taras-01.jpg", alt: "Zadaszony taras domku O Sole Mio ze stołem i lampami" },
        ],
        features: ["Prywatne jacuzzi", "Miejsce na ognisko", "Podwójne łóżko", "Aneks kuchenny", "Hamak", "Szybkie Wi-Fi", "Klimatyzacja i ogrzewanie", "Przeszklona ściana", "Grill"],
    },
    {
        id: "dolce-vita",
        name: "DOLCE VITA",
        guests: "2–4 osoby",
        area: "25 m²",
        tags: ["Jacuzzi", "Kino letnie"],
        desc: "Letnie kino plenerowe i długie wieczory przy ognisku — dla tych, którzy lubią celebrować czas.",
        image: "/images/dolce-vita/dolce-vita-domek-wynajem.jpg",
        imageAlt: "Domek Dolce Vita na wynajem nad Liwcem na Mazowszu",
        imageTitle: "Dolce Vita – domek na wynajem nad Liwcem",
        gallery: [
            { src: "/images/dolce-vita/tilio-seklak-domek-kuchnia-03.jpg", alt: "Aneks kuchenny i jadalnia w domku Dolce Vita", title: "Dolce Vita – kuchnia i jadalnia" },
            { src: "/images/dolce-vita/tilio-sauna-rzeka-mazowsze-04.JPG", alt: "Balia i taras przy domku Dolce Vita na Mazowszu", title: "Dolce Vita – balia na tarasie" },
            { src: "/images/dolce-vita/tilio-mazowieckie-05.jpg", alt: "Przytulne wnętrze domku Dolce Vita", title: "Dolce Vita – wnętrze domku" },
            { src: "/images/dolce-vita/tilio-las-jacuzzi07.jpg", alt: "Jacuzzi przy domku Dolce Vita wśród zieleni", title: "Dolce Vita – jacuzzi w otoczeniu natury" },
            { src: "/images/dolce-vita/tilio-domek-nad-rzeka-mazowsze-08.jpg", alt: "Domek Dolce Vita w otoczeniu natury na Mazowszu", title: "Dolce Vita – domek wśród natury" },
            { src: "/images/dolce-vita/tilio-domek-jacuzzi-rzeka-mazowsze-09.jpg", alt: "Jacuzzi przy domku Dolce Vita nad rzeką Liwiec", title: "Dolce Vita – jacuzzi nad Liwcem" },
            { src: "/images/dolce-vita/tilio-relax-las_11.jpg", alt: "Domek Dolce Vita z tarasem i hamakiem na leśnej polanie", title: "Dolce Vita – relaks na polanie" },
            { src: "/images/dolce-vita/tilio-sekłak-wynajem-domek-wnętrze-12.jpg", alt: "Salon domku Dolce Vita z antresolą i dużymi oknami", title: "Dolce Vita – salon z antresolą" },
            { src: "/images/dolce-vita/tilio-sełkak-grill-13.jpg", alt: "Grill i strefa wypoczynku przy domku Dolce Vita", title: "Dolce Vita – strefa grilla" },
        ],
        features: ["Prywatne jacuzzi", "Miejsce na ognisko", "Podwójne łóżko", "Aneks kuchenny", "Hamak", "Szybkie Wi-Fi", "Klimatyzacja i ogrzewanie", "Kino letnie", "Grill"],
    },
];

export const AMENITIES = [
    {
        group: "W domku",
        icon: "BedDouble",
        items: [
            "W pełni wyposażony aneks kuchenny",
            "Lodówka, kawiarka, czajnik",
            "Klimatyzacja i ogrzewanie",
            "Szybkie Wi-Fi",
            "Łazienka z prysznicem",
            "Pościel i ręczniki",
        ],
    },
    {
        group: "Na miejscu",
        icon: "Trees",
        items: [
            "Prywatna sauna i jacuzzi",
            "Miejsce na ognisko i grill",
            "Hamaki i leżaki",
            "Parking przy domkach",
            "Leśne ścieżki spacerowe",
            "Gabinet masażu i medytacji – 100 m od domku.",
        ],
    },
    {
        group: "Dla każdego",
        icon: "Heart",
        items: [
            "Miski i kocyk dla psa",
            "Ogrodzony teren",
            "Ognisko pod gwiazdami",
            "Spokojna, zielona okolica",
            "Trasy rowerowe w pobliżu",
            "Wędrówki wzdłuż rzeki",
        ],
    },
];

export const ACTIVITIES = [
    { icon: "Hand", label: "MASAŻ" },
    { icon: "Sailboat", label: "KAJAK" },
    { icon: "Bike", label: "ROWERY" },
    { icon: "Footprints", label: "SPACER" },
    { icon: "FlameKindling", label: "OGNISKO" },
    { icon: "Clapperboard", label: "KINO LETNIE" },
];

export const DISTANCES = [
    { icon: "Car", text: "Około 1 godziny jazdy od Warszawy" },
    { icon: "ShoppingBag", text: "5 minut do najbliższego sklepu" },
    { icon: "CarFront", text: "15 minut do Łochowa" },
    { icon: "TrainFront", text: "Stacja kolejowa w Łochowie" },
    { icon: "UtensilsCrossed", text: "Restauracje, kawiarnie i duże centrum handlowe w Łochowie" },
    { icon: "Trees", text: "Dzika, spokojna przyroda doliny Liwca" },
];

export const REVIEWS = [
    {
        text: "Wspaniałe miejsce! Przytulne domki, a do wyboru jacuzzi albo sauna z dostępem do rzeki. Piękne, spokojne otoczenie — gorąco polecam ❤️ Do tego przyjazne zwierzętom 🐕",
        author: "Opinia Google",
        context: "",
    },
    {
        text: "Przepiękne domki w cudownej okolicy. Gospodarz bardzo miły i sympatyczny.",
        author: "Opinia Google",
        context: "",
    },
    {
        text: "Świetne miejsce — spokojne, otoczone lasem, a w pobliżu płynie rzeka. Można też przyjechać z psem.",
        author: "Opinia Google",
        context: "",
    },
];

export const FAQ = [
    {
        category: "Rezerwacja i pobyt",
        items: [
            { q: "Jak sprawdzić dostępność i zarezerwować domek?", a: "Kliknij „Sprawdź dostępność”, wybierz domek i zaznacz interesujące Cię daty w kalendarzu. Zajęte terminy są przekreślone. Po wysłaniu zapytania potwierdzamy rezerwację w ciągu 24 godzin." },
            { q: "Ile kosztuje pobyt w Tilio?", a: "Cena zależy od domku, terminu i długości pobytu. Dokładną wycenę otrzymasz w odpowiedzi na zapytanie o wybrany termin." },
            { q: "Co obejmuje cena pobytu?", a: "Cena obejmuje pobyt w domku, pościel, ręczniki, dostęp do sauny lub jacuzzi (zależnie od domku), miejsce na ognisko oraz parking." },
            { q: "Jak wygląda anulowanie lub zmiana rezerwacji?", a: "Rezerwację można bezpłatnie zmienić lub anulować do 14 dni przed przyjazdem. W późniejszym terminie obowiązuje częściowa opłata — szczegóły przesyłamy przy potwierdzeniu." },
            { q: "O której jest zameldowanie i wymeldowanie?", a: "Zameldowanie od godziny 15:00, wymeldowanie do godziny 11:00. W miarę możliwości oferujemy elastyczne godziny — daj nam znać wcześniej." },
        ],
    },
    {
        category: "Domki",
        items: [
            { q: "Ile osób może nocować w domku?", a: "Wygodne dwuosobowe łóżko na antresoli, niewielka rozkładana sofa w części dziennej oraz jednoosobowe łóżko na mniejszej antresoli. To tiny house, dlatego im mniejsza ekipa, tym wygodniej — o tym zawsze uprzedzamy naszych gości." },
            { q: "Czym różnią się trzy domki Tilio?", a: "TILIO stoi najbliżej rzeki i ma saunę, O SOLE MIO ma prywatne jacuzzi i dużą przeszkloną ścianę, a DOLCE VITA — jacuzzi i letnie kino plenerowe." },
            { q: "Czy domki są ogrzewane i można przyjechać zimą?", a: "Tak. Wszystkie domki są ogrzewane i klimatyzowane, działamy cały rok — zima nad Liwcem ma swój klimat." },
            { q: "Co dokładnie znajdę w domku?", a: "Aneks kuchenny z lodówką i kawiarką, łazienkę z prysznicem, pościel, ręczniki, Wi-Fi oraz taras z miejscem do siedzenia." },
            { q: "Czy każdy domek ma kuchnię i łazienkę?", a: "Tak, każdy z trzech domków ma własny, w pełni wyposażony aneks kuchenny oraz prywatną łazienkę z prysznicem." },
        ],
    },
    {
        category: "Psy i dzieci",
        items: [
            { q: "Chcę przyjechać z psem — czy Tilio jest na to odpowiednie?", a: "Jak najbardziej. Psy są u nas mile widziane, w domku czekają miski i kocyk, a teren posesji jest ogrodzony." },
            { q: "Czy teren jest ogrodzony?", a: "Tak, cała posesja jest ogrodzona, więc pies może bezpiecznie biegać po terenie." },
            { q: "Czy mogę zostawić psa samego w domku?", a: "Prosimy, by nie zostawiać psa samego na dłużej niż krótka chwila — nowe miejsce bywa dla niego stresujące." },
            { q: "Czy Tilio jest odpowiednie dla dzieci?", a: "Tak, choć bliskość rzeki wymaga nadzoru nad najmłodszymi. Teren jest zielony i bezpieczny do zabawy." },
            { q: "Czy pobyt psa jest płatny?", a: "Nie pobieramy opłaty za pobyt psa. Prosimy jedynie o pokrycie kosztu dodatkowego sprzątania w wysokości 50 zł." },
            { q: "Czy w domku można przygotować pobyt z małym dzieckiem?", a: "Na życzenie przygotujemy łóżeczko dziecięce i krzesełko do karmienia — wystarczy wspomnieć o tym w zapytaniu." },
        ],
    },
    {
        category: "Sauna, jacuzzi, masaż i gongi",
        items: [
            { q: "Czy sauna i jacuzzi są prywatne?", a: "Tak. Każdy domek ma własną saunę lub jacuzzi na wyłączność – niczego nie dzielisz z innymi gośćmi." },
            { q: "Czy są wliczone w cenę pobytu?", a: "Tak, korzystanie z sauny i jacuzzi jest wliczone w cenę pobytu, bez dodatkowych opłat." },
            { q: "Czy można korzystać z nich przez cały rok?", a: "Tak, sauna i jacuzzi działają niezależnie od pory roku — także zimą. Jacuzzi nie rozpalamy, jeśli temperatura spadnie poniżej -15°C." },
            { q: "Czy mogę umówić masaż lub seans gongów?", a: "Tak, we współpracy z gabinetem Małgorzaty Dec (100 m od domków) oferujemy masaże i seanse gongów dla gości Tilio." },
            { q: "Czy zabiegi trzeba rezerwować wcześniej?", a: "Zalecamy rezerwację zabiegów z kilkudniowym wyprzedzeniem — napisz do nas, a umówimy dogodny termin." },
        ],
    },
    {
        category: "Dojazd i lokalizacja",
        items: [
            { q: "Jak daleko Tilio jest od Warszawy?", a: "Około godziny jazdy samochodem z Warszawy — blisko wystarczająco, by przyjechać nawet na jeden weekend." },
            { q: "Gdzie znajduje się najbliższy sklep?", a: "Najbliższy sklep jest 5 minut drogi od domków, większe zakupy zrobisz w Łochowie (15 minut)." },
            { q: "Gdzie jest najbliższa stacja kolejowa?", a: "Najbliższa stacja kolejowa znajduje się w Łochowie, około 15 minut jazdy od Tilio." },
            { q: "Czy da się dojechać bez samochodu?", a: "Tak — pociągiem do Łochowa, a stamtąd taksówką lub wcześniej umówionym odbiorem. Napisz do nas, pomożemy to zorganizować." },
            { q: "Czy przy domkach jest parking?", a: "Tak, na posesji znajduje się bezpłatny parking dla gości, tuż przy domkach." },
        ],
    },
    {
        category: "Rzeka i aktywności",
        items: [
            { q: "Jak blisko domków jest rzeka Liwiec?", a: "Dosłownie kilka kroków — zejście do wody jest bezpośrednio z terenu posesji." },
            { q: "Czy można się kąpać w rzece?", a: "Tak, Liwiec to czysta, spokojna rzeka z piaszczystymi odcinkami brzegu — latem kąpiel to codzienność." },
            { q: "Czy mogę pływać kajakiem?", a: "Tak, kajaki są dostępne na zamówienie za dodatkową opłatą." },
            { q: "Czy można łowić ryby?", a: "Tak, w okolicy znajdują się łowiska. Pamiętaj o wymaganym zezwoleniu i kartach wędkarskich." },
            { q: "Co jeszcze można robić w okolicy?", a: "Trasy rowerowe, leśne spacery, kino letnie na miejscu, ogniska wieczorem i zabiegi w gabinecie masażu i medytacji 100 metrów od domków." },
        ],
    },
    {
        category: "Wyposażenie i udogodnienia",
        items: [
            { q: "Czy w domku jest Wi-Fi?", a: "Tak, w każdym domku działa szybkie Wi-Fi — możesz połączyć pracę z pobytem nad rzeką." },
            { q: "Czy są pościel i ręczniki?", a: "Tak, pościel i ręczniki są zawsze w cenie — nie musisz niczego zabierać ze sobą." },
            { q: "Co znajduje się w kuchni?", a: "Lodówka, płyta grzewcza, kawiarka, czajnik, dzbanek filtrujący Brita, garnki, patelnia i komplet naczyń ze sztućcami." },
            { q: "Czy jest klimatyzacja?", a: "Tak, każdy domek ma klimatyzację i ogrzewanie, więc komfort nie zależy od pogody." },
            { q: "Czy są dostępne udogodnienia dla osób z niepełnosprawnościami?", a: "Domki są parterowe z niskim progiem. Napisz do nas przed przyjazdem — postaramy się przygotować wszystko, co potrzebne." },
        ],
    },
    {
        category: "Zasady pobytu",
        items: [
            { q: "Czy w Tilio można organizować imprezy?", a: "Tilio to miejsce ciszy i natury — nie organizujemy głośnych imprez. Kameralne spotkania przy ognisku jak najbardziej." },
            { q: "Czy obowiązuje cisza nocna?", a: "Tak, cisza nocna obowiązuje od 22:00 do 7:00 — z szacunku do innych gości i do samej rzeki." },
            { q: "Czy można palić w domkach?", a: "Nie, w domkach obowiązuje całkowity zakaz palenia. Na zewnątrz wyznaczyliśmy miejsce dla palących." },
            { q: "Czy można robić ogniska?", a: "Tak, w wyznaczonym miejscu na ognisko — drewno czeka na miejscu, w cenie pobytu." },
            { q: "Czy mogę zaprosić osoby z zewnątrz?", a: "Dziennych gości można zaprosić po wcześniejszym uzgodnieniu z nami. Nocleg przysługuje wyłącznie osobom zgłoszonym w rezerwacji." },
        ],
    },
];

export const RHYTHMS = [
    {
        slug: "natura",
        title: "NATURA",
        tags: "Liwiec • las • spacer • hamak",
        desc: "Dla tych, którzy chcą pobyć blisko natury.",
        activities: [
            { name: "Liwiec", text: "Zejście do rzeki prosto z posesji — poranna kąpiel lub wieczorne siedzenie nad wodą." },
            { name: "Las", text: "Leśne ścieżki zaczynają się tuż za ogrodzeniem." },
            { name: "Spacer", text: "Kilka tras wzdłuż rzeki: od krótkiej przechadzki po całodniową wędrówkę." },
            { name: "Hamak", text: "Hamaki i leżaki wśród drzew — miejsce na książkę i popołudniową drzemkę." },
        ],
    },
    {
        slug: "cialo",
        title: "CIAŁO",
        tags: "sauna • rzeka • masaż",
        desc: "Dla tych, którzy chcą zwolnić i zadbać o ciało.",
        activities: [
            { name: "Sauna", text: "Prywatna sauna przy domku TILIO — tylko dla Ciebie, o każdej porze roku." },
            { name: "Rzeka", text: "Chłodna kąpiel w Liwcu po saunie — najprostszy rytuał, jaki znamy." },
            { name: "Jacuzzi", text: "Jacuzzi przy domkach O Sole Mio i Dolce Vita dostępne przez cały rok, z wyjątkiem dni, w których temperatura spadnie poniżej -15°C." },
            { name: "Masaż", text: "Masaże i seanse gongów w gabinecie Małgorzaty Dec, 100 metrów od domków." },
        ],
    },
    {
        slug: "skupienie",
        title: "SKUPIENIE",
        tags: "praca • cisza • Wi-Fi",
        desc: "Dla tych, którzy chcą pracować w spokojnym otoczeniu.",
        activities: [
            { name: "Praca", text: "Wygodne miejsce do pracy w każdym domku — przy stole albo na tarasie nad wodą." },
            { name: "Cisza", text: "Brak miejskiego tła — tylko woda, wiatr i ptaki. Na posesji obowiązuje cisza nocna." },
            { name: "Wi-Fi", text: "Szybkie, stabilne łącze." },
            { name: "Własna przestrzeń", text: "Domek i taras tylko dla Ciebie — nikt nie przeszkadza w trakcie pracy." },
        ],
    },
];
